import { render, staticRenderFns } from "./postDetail.vue?vue&type=template&id=c09599f0&scoped=true&"
import script from "./postDetail.js?vue&type=script&lang=js&"
export * from "./postDetail.js?vue&type=script&lang=js&"
import style0 from "./postDetail.css?vue&type=style&index=0&id=c09599f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09599f0",
  null
  
)

export default component.exports